import { MdAdd, MdEdit, MdOutlineRemove } from 'react-icons/md'

import type { MouseEvent, ReactElement } from 'react'
import type { IVideoTag } from '~/types/video'

import { VideoTagBadge } from '~/components/Badges'
import Button from '~/components/Buttons/Button'
import Tooltip from '~/components/Tooltip'
import VideoPreview from '~/components/VideoPreview'

import './styles.scss'

export interface Props {
  description?: string
  favourite?: boolean
  onAddToFavourite: VoidFunction
  onClick: (event: MouseEvent<HTMLDivElement>) => void
  onEdit: VoidFunction
  tags: IVideoTag[]
  title: string
  url: string
}

const VideoCard = ({
  description,
  favourite,
  onAddToFavourite,
  onClick,
  onEdit,
  tags,
  title,
  url,
}: Props): ReactElement => {
  const formatLinksFromDescription = () => {
    const splittedDesc = description ? description.split(' ') : []

    return splittedDesc.map((word, i) => {
      if (word.startsWith('https://') || word.startsWith('http://')) {
        return (
          <>
            {i !== 0 ? ' ' : ''}
            <a className="link" href={word} key={`${word}-${i}`}>
              {word}
            </a>
          </>
        )
      }
      return (
        <>
          {i !== 0 ? ' ' : ''}
          {word}
        </>
      )
    })
  }

  return (
    <div className="video-card">
      <div className="video-card__video-content" onClick={onClick}>
        <VideoPreview autoplay clickable={false} controls={false} muted url={url} />
      </div>
      <div className="video-card__content">
        <div className="video-card__content__header">
          <div className="video-card__content__title">{title}</div>
          <div className="video-card__content__actions">
            <Tooltip
              className="actions-menu-tooltip"
              overlay={favourite ? 'Remove from My list' : 'Add to My list'}
              placement="top"
              trigger="hover"
            >
              <Button className="favourite-button" onClick={onAddToFavourite} outlined>
                {favourite ? <MdOutlineRemove color="#ff5301" size={14} /> : <MdAdd color="#ff5301" size={14} />}
              </Button>
            </Tooltip>
            <Tooltip className="actions-menu-tooltip" overlay="Edit video" placement="top" trigger="hover">
              <Button className="edit-button" onClick={onEdit} outlined>
                <MdEdit color="#ff5301" size={14} />
              </Button>
            </Tooltip>
          </div>
        </div>
        <div className="video-card__content__tags">
          {tags.map((tag, index) => (
            <VideoTagBadge key={`tag-${index}`} value={tag.name} />
          ))}
        </div>
        <div className="video-card__content__description">{formatLinksFromDescription()}</div>
      </div>
    </div>
  )
}

export default VideoCard
